<template>
  <div id="appStart">
    <ReviewWebsite ref="reviewwebsite" @success="finishedreview" />

    <BHNavbar :is-loggedin="isLoggedin" :display-user="fullName" @login="LoginModal" @logout="logoutAuthen" />

    <!-- DEPRECATED USE "BHNavbar" COMPONENT INSTEAD (IF THAT COMPONENT FAIL USE THIS OLD CODE INSTEAD, BUT WILL LACK OF MOBILE NAV MENU)
    <div
      id="nav"
      style="
        background-color: #404040;
        padding: unset !important;
        color: white !important;
      "
    >
     
      <b-navbar class="container toggleable" style="padding: unset !important">
        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="w-100 px-2 px-sm-0 d-flex justify-content-end align-items-center">
            <b-nav-item class="login-name">
              <div class="d-flex justify-content-center align-items-center">
                <b-icon icon="person" style="color: #ffd400" class="mr-2"></b-icon>
                <div v-if="isLoggedin">
                  <b-dropdown
                    size="sm"
                    variant="link"
                    no-caret
                    menu-class="userSelectdropdown"
                  >
                    <template #button-content>
                      <div class="xd-text w-regular s-14 text-white">
                        {{ displayUsertext }}
                      </div>
                    </template>
                    <b-dropdown-item to="/Account/PurchaseHistory"
                      >ประวัติสั่งซื้อ</b-dropdown-item
                    >
                    <b-dropdown-item to="/Account/Account-MyEBook"
                      >E-Book ของฉัน</b-dropdown-item
                    >
                    <b-dropdown-item to="/Account/MyFavorite"
                      >รายการโปรด</b-dropdown-item
                    >
                    <b-dropdown-item to="/Account/Address"
                      >ที่อยู่จัดส่ง</b-dropdown-item
                    >
                    <b-dropdown-item to="/Account/Receipt"
                      >ดาวน์โหลดใบเสร็จ</b-dropdown-item
                    >
                    <b-dropdown-item to="/Account/ProductReturn"
                      >รายการคืนสินค้า</b-dropdown-item
                    >
                    <b-dropdown-item to="/Account/ProfileSetting"
                      >แก้ไขข้อมูลของฉัน</b-dropdown-item
                    >
                    <b-dropdown-item to="/Account/ChangePassword"
                      >ตั้งค่ารหัสผ่าน</b-dropdown-item
                    >
                    <b-dropdown-item @click="logoutAuthen"
                      ><div style="color: red">ออกจากระบบ</div></b-dropdown-item
                    >
                  </b-dropdown>
                </div>
                <div v-if="!isLoggedin" @click="LoginModal" class="xd-text w-regular s-14">
                  เข้าสู่ระบบ/ลงทะเบียน
                </div>
              </div>
            </b-nav-item>
            <b-nav-item href="#" to="/cart" style="padding-left:unset!important;margin-left:unset!important;">
              <div class="d-flex justify-content-center align-items-center">
                <b-icon icon="basket" style="color: #ffd400" class="mr-2"></b-icon>
                <span class="xd-text w-regular s-14">{{ this.$store.getters.gettotalBook }} เล่ม</span>
              </div>
            </b-nav-item>
            <b-nav-item href="#" class="padding-nav-item" style="z-index:100;background-color: rgb(64, 64, 64);padding:unset !important" id="customautocomplete">
              <BookAutoComplete v-bind:display="true"></BookAutoComplete>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
      <div class="w-100 d-flex justify-content-end align-items-center autocomplete-moblie" style="background-color: rgb(64, 64, 64);">
        <BookAutoCompleteForMobile v-bind:display="true"></BookAutoCompleteForMobile>
      </div>
      <div class="show-pc logo-brand text-center" style="height: 140px;">
        <img style="" src="../assets/LogoWeb.png" height="100%" />
      </div>
      <div class="show-m logo-brand text-left" style="height: 70px;">
        <img src="../assets/LogoWeb.png" height="100%" />
        <img src="../assets/menu.svg" />
      </div>
      <b-nav
        align="center"
        class="navbar-height show-pc-nav"
        is-nav
        style="padding-bottom: unset !important"
      >
        <b-nav-item class="navmenu-item" to="/">หน้าหลัก</b-nav-item>

        <b-nav-item class="navmenu-item" to="/bookstore">คลังหนังสือ</b-nav-item>

        <b-nav-item class="navmenu-item" to="/about">เกี่ยวกับเรา</b-nav-item>

        <b-nav-item class="navmenu-item" to="/howtoroder">วิธีการสั่งซื้อ</b-nav-item>

        <b-nav-item class="navmenu-login" to="/Subscription">เข้าสู่ระบบสมาชิก</b-nav-item>
      </b-nav>
    </div> -->

    <router-view />
    <div id="footer" style="background-color: #02364C; border-bottom: 6px solid #FFD400;" class="text-light">
      <div class="container pt-5 pb-2">
        <div class="row px-4">


          <div class="col-md-6 col-lg-4 col-12 px-0 px-sm-5 mb-3 mb-sm-3" style="padding-left: 1rem !important; padding-right: 1rem !important;">
            <div class="text-left text-sm-center">
              <img
                class="img-fluid"
                style="max-width:100% !important;"
                width="80%"
                height="80%"
                src="../assets/LogoWeb.png"
              />
            </div>

            <div class="row no-gutters mt-3 mt-sm-5">
              <div class="col-12 mb-3 mb-sm-3 xd-text s-14 w-medium">จำนวนผู้เข้าชมเว็บไซต์</div>
              <div class="col-6 col-sm-12 mb-3 mb-sm-3">
                <div class="row no-gutters">
                  <div class="col-5 col-sm-7 footer__detail d-flex align-items-center xd-text s-14 w-regular">เข้าชมวันนี้</div>
                  <div class="col-7 col-sm-5 text-right">
                    <input
                      type="number"
                      disabled
                      :value="getNumber(VisitToday)"
                      class="statistics form-control w-100 xd-text s-14 w-regular"
                    />
                  </div>
                </div>
              </div>
              <div class="col-6 col-sm-12 mb-3 mb-sm-3">
                <div class="row no-gutters">
                  <div class="col-5 col-sm-7 footer__detail d-none d-sm-flex align-items-center pl-2 pl-sm-0 xd-text s-14 w-regular">สถิติ</div>
                  <div class="col-5 col-sm-7 footer__detail d-flex d-sm-none align-items-center justify-content-end pr-2 pl-sm-0  xd-text s-14 w-regular">สถิติ</div>
                  <div class="col-7 col-sm-5 text-right">
                    <input
                      type="text"
                      disabled
                      :value="getNumber(VisitAll)"
                      class="statistics form-control w-100 xd-text s-14 w-regular"
                    />
                  </div>
                </div>
              </div>
              <div class="col-12">
                <b-button variant="warning" class="w-100 py-1 py-sm-2 footer-btn xd-text s-14 w-regular" @click="review">แสดงความคิดเห็น</b-button>
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 col-12 px-0 px-sm-5 text-left" style="padding-left: 1rem !important; padding-right: 1rem !important;">
            <h4 class="mb-2 mb-sm-5"><span class="footer-title xd-text s-18 w-regular w-sm-bold">บริการทั่วไป</span></h4>
            <p class="footer-text">
              <a class="footer-shortcut xd-text s-14 w-regular" href="https://dictionary.orst.go.th/">พจนานุกรม ฉบับราชบัณฑิตยสถาน พ.ศ. 2554</a><br />
              <a class="footer-shortcut xd-text s-14 w-regular" href="https://coined-word.orst.go.th/">ศัพท์บัญญัติ สำนักงานราชบัณฑิตยสภา</a><br />
              <a class="footer-shortcut xd-text s-14 w-regular" href="https://transliteration.orst.go.th/">ระบบฐานข้อมูลคำทับศัพท์สำนักงานราชบัณฑิตยสภา</a><br />
              <a class="footer-shortcut xd-text s-14 w-regular" href="https://etest.orst.go.th/">ระบบทดสอบความรู้ด้านภาษาไทย</a><br />
              <a class="footer-shortcut xd-text s-14 w-regular" href="http://164.115.33.116/">พจนานุกรมภาษามือไทย ฉบับราชบัณฑิตยสภา</a><br />
              <a class="footer-shortcut xd-text s-14 w-regular" href="https://www.orst.go.th/iwfm_table.asp?a=28">คลังความรู้</a><br />
              <a class="footer-shortcut xd-text s-14 w-regular" href="/howtoroder">ขั้นตอนการสั่งซื้อหนังสือและวิธีการชำระเงิน</a><br />
              <a class="footer-shortcut xd-text s-14 w-regular" href="https://www.orst.go.th/iwfm_table.asp?a=37">คำถามที่ถามบ่อย (FAQ)</a><br />
            </p>
          </div>

          <div class="col-md-6 col-lg-4 col-12 px-0 px-sm-5 text-left" style="padding-left: 1rem !important; padding-right: 1rem !important;">
            <h4 class="mb-2 mb-sm-3">
              <span class="footer-title xd-text s-18 w-regular w-sm-bold">
                ติดต่อสำนักงานราชบัณฑิตยสภา<br/>
                ( ห้องจำหน่ายหนังสือ )
              </span>
            </h4>
            <p class="footer-text xd-text s-14 w-regular">
              สนามเสือป่า ถนนศรีอยุธยา<br />
              เขตดุสิต กรุงเทพมหานคร 10300<br />
              โทรศัพท์ 0 2356 0466-70 ต่อ 1020<br />
              โทรสาร 0 2356 0492<br />
              อีเมล ripub@orst.go.th<br />
            </p>

            <div class="d-none d-sm-block px-5 px-sm-0 mb-2">
              <div
                class="fb-page"
                data-href="https://www.facebook.com/RatchabanditThai/"
                data-width="380"
                data-hide-cover="false"
                data-show-facepile="false"
              ></div>
            </div>
          </div> 
        </div>

        <div class="d-block d-sm-none px-5 mb-2">
          <div
            class="fb-page"
            data-href="https://www.facebook.com/RatchabanditThai/"
            data-width="380"
            data-hide-cover="false"
            data-show-facepile="false"
          ></div>
        </div>

        <div class="text-left row">
          <div class="col footer-text">
            <hr class="mb-2" style="background-color: white" />
            <span class="px-2 xd-text w-regular s-14">สงวนลิขสิทธิ์ © พ.ศ. 2564 สำนักงานราชบัณฑิตยสภา</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
// #appStart {
//   font-family: Avenir, Helvetica, Arial, sans-serif;
//   -webkit-font-smoothing: antialiased;
//   -moz-osx-font-smoothing: grayscale;
//   text-align: center;
//   color: #2c3e50;
// }
body {
  overflow: hidden; /* Hide scrollbars */
}
#customautocomplete {
  transition: width 2s;
  width: 240px;
}
@media screen and (max-width: 960px) {
  #customautocomplete {
    display: none !important;
    /* Add other properties here */
  }
}

.autocomplete-moblie {
  display: none !important;
}
@media screen and (max-width: 960px) {
  .autocomplete-moblie {
    display: flex !important;
    /* Add other properties here */
  }
}

#nav {
  padding: 30px;

  a {
    font-weight: 500;
    color: white;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

a.footer-shortcut {
  font-weight: medium;
  color: white;
}

a.footer-shortcut:hover {
  color: #ffd400;
  text-decoration: none;
}

.padding-nav-item {
  padding: 5px;
}

img.resize {
  max-height: 50%;
}

// .footer-padding {
//   padding-left: 100px;
//   padding-right: 100px;
//   padding-top: 50px;
// }

.footer__detail {
  font-weight: 300;
  font-size: 14px;
}

.statistics {
  border-radius: 25px;
  border: 2px solid transparent;
  padding: 15px;
  width: 150px;
  height: 15px;
  background-color: white;
  text-align: center;
  -webkit-appearance: none;
  -moz-appearance: textfield;
}

.center-height {
  height: 20px;
  line-height: 20px;
  padding: 15px;
  border: 1px solid #666;
}

.link-bookstore {
  text-decoration: underline;
  color: black;
}
.link-createaccount {
  text-decoration: underline;
  color: #ffd400;
  cursor: pointer;
}
#nav a.router-link-exact-active {
  color: white !important;
  font-weight: 600;
}
#nav a.router-link-exact-active {
  color: white !important;
  border-bottom: 3px solid white;
}
.dropdown-item:active {
  background-color: #ffd400;
}
.modal-dialog {
  justify-content: center !important;
  /*display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  border: 3px solid green;*/
  /*margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  margin-left: 100px;
  margin-top: 25px;
  margin-right:unset;
  margin-bottom:unset;*/
}
.login-modal-dialog {
  max-width: unset !important;
}
.modal-content-my {
  width: 1000px;
  background-image: url("../assets/Login-bg.png");
  background-color: unset;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 25px;
  padding-right: 40px;
  border: unset;
  /*opacity: 0.8;*/
}
.logo-brand {
  height: 175px;
  padding: 20px;
}
@media only screen and (max-width: 991px) {
  .logo-brand {
    height: 175px;
    padding: 10px;
  }
}
.padding-logo-footer {
  padding: 15px;
}
.login-name > b-icon {
  display: inline-block;
}
.login-name div {
  display: inline-block;
}

.login-name div b-dropdown {
  display: inline-block;
}
.userSelectdropdown li a {
  font-weight: normal !important;
  color: black !important;
}
.btn-sm {
  padding: 0 0 0 0 !important;
}
.btn-link:hover{
  text-decoration: none !important;
}
.btn-link:focus{
  text-decoration: none !important;
}
#nav a.router-link-exact-active {
  color: unset !important;
  font-weight: bold !important;
}
input[type="number"] {
  font-size: unset !important;
}
.footer-title {
  font-weight: 500;
}
@media (max-width: 767px) {
  .footer-title {
    font-size: 80%;
    font-weight: 400;
  }
  .footer-text {
    font-size: 80%;
    line-height: 2em;
  }
  .footer-btn {
    font-size: 90%;
    font-weight: 500;
    color: #fff;
  }
  .statistics {
    font-weight: 500;
    color: #495057;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
}
</style>
<script>
import AuthenService from "../services/authen.service.js";
import { mapGetters, mapActions } from "vuex";
import { GlobalAuthenDialog } from "../libs/GlobalAuthenDialog.js";
import ReviewWebsite from "@/components/ReviewWebsite";
import BookAutoComplete from "@/components/BookAutoComplete";
import BookAutoCompleteForMobile from "@/components/BookAutoCompleteForMobile";
import BHNavbar from "@/components/BHNavbar";
import axios from "axios";
export default {
  components: {
    ReviewWebsite,
    // // BookAutoComplete,
    // BookAutoCompleteForMobile,
    BHNavbar
  },
  computed: {
    ...mapGetters(["gettotalBook", "fullName", "isLoggedin"])
  },
  data() {
    return {
      cart: [],
      VisitStatistic: null,
      VisitToday: 0,
      VisitAll: "0",
      ShowAutoComplete: false,
      ShowAutoComplete2: false
    };
  },
  methods: {
    LoginModal() {
      GlobalAuthenDialog.start();
    },
    logoutAuthen() {
      AuthenService.logout();
      this.$store.dispatch("loadUserInfo");
    },
    review() {
      if (AuthenService.isAuthenticated) {
        this.$refs["reviewwebsite"].showmodal();
      } else {
        GlobalAuthenDialog.start();
      }
    },
    finishedreview() {},
    checkAuthen() {
      this.$store.dispatch("loadUserInfo");
    },
    AddVisitStatistics() {
      this.axios.post("/Statistics/AddVisitStatic").then(res => {});
    },
    getNumber(number) {
      return Number(number).toLocaleString();
    },
    displayautocomplete() {
      this.ShowAutoComplete = !this.ShowAutoComplete;
      if (this.ShowAutoComplete) {
        document.getElementById("customautocomplete").style.width = "210px";
        //setTimeout(() => this.ShowAutoComplete2 = true,1500);
      } else {
        document.getElementById("customautocomplete").style.width = "0px";
      }
    },
    LoadVisitStatistics() {
      this.axios.post("/Statistics/GetVisitStatic").then(res => {
        this.VisitStatistic = res.data;
        this.VisitToday = this.VisitStatistic.today;
        this.VisitAll = this.VisitStatistic.all;
      });
    },
    ...mapActions(["settotalBook"])
  },
  created: function() {
    this.checkAuthen();
    if (this.isLoggedin) {
      this.axios
        .get("/Cart?sort=CreatedDate&sortDirection=asc")
        .then(response => {
          let booktotal = 0;
          response.data.resultData.forEach(function(item) {
            booktotal += item.number;
          });
          this.settotalBook(parseInt(booktotal));
        });
    }
  },
  mounted() {
    this.AddVisitStatistics();
    this.LoadVisitStatistics();
  }
};
</script>
